import { string } from 'yup';

const rule = {
	name: 'restrictedCharacters',
	method ({ message } = { message: 'This field does not accept < or >' }) {

		return this.test('restrictedCharacters', message, function (value) {

			const match = RegExp('^[^<>]+$');
			const { createError } = this;
			return match.test(value) || createError({ message });

		});

	},
	schemaType: string
};

export default rule;
